import { render, staticRenderFns } from "./model-r1-layer-inference.vue?vue&type=template&id=532d15e8&scoped=true&"
import script from "./model-r1-layer-inference.vue?vue&type=script&lang=js&"
export * from "./model-r1-layer-inference.vue?vue&type=script&lang=js&"
import style0 from "./model-r1-layer-inference.vue?vue&type=style&index=0&id=532d15e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532d15e8",
  null
  
)

export default component.exports